<template>
    <div>
        <div role="link" class="interior-list" v-if="beforeAfter">
            <div class="compare-grid__images">
                <div class="compare-slide">
                <!-- 
                    ※ 썸네일 이미지 사이즈
                    가로/세로 비율: 1.75
                    Before, After 사진 사이즈 동일해야함.
                -->

                <!-- 썸네일: Before -->
                    <div class="image">
                        <img class="thumb" :src="portfolio.space.beforeImage" alt="">
                    </div>
                    <!-- 썸네일: After -->
                    <div class="image image-overlay">
                        <img class="thumb" :src="portfolio.space.afterImage" alt="">
                    </div>
                </div>
            </div>

            <div @click="$emit('click', portfolio )">
                <span class="interior-list__title">{{ portfolio.subject }}</span>
                <ul class="interior-list__infos">
                    <li class="interior-list__info">{{ portfolio.category.name }}</li>
                    <li class="interior-list__info">{{ portfolio.space.type }}</li>
                    <li v-if="portfolio.user" class="interior-list__info">{{ portfolio.user.meta.companyName }}</li>
                </ul>
            </div>
        </div>

        <div role="link" class="interior-list" @click="$emit('click', portfolio )" v-else>
            <span class="interior-list__thumb">
                <span class="interior-list__thumbnail">
                    <span class="interior-list__thumbnail-image" :style="{ 'backgroundImage': `url('${portfolio.space.afterImage}')` }"></span>
                </span>
            </span>
            <div>
                <span class="interior-list__title">{{ portfolio.subject }}</span>
                <ul class="interior-list__infos">
                    <li class="interior-list__info">{{ portfolio.category.name }}</li>
                    <li class="interior-list__info">{{ portfolio.space.type }}</li>
                    <li v-if="portfolio.user" class="interior-list__info">{{ portfolio.user.meta.companyName }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        portfolio: { type: Object, default: null },
        beforeAfter: { type: Boolean, default: false }
    },
}
</script>

<style lang="css" scoped>
</style>
